import React from 'react';
import Lottie from 'lottie-react';
import LoaderAnimation from 'assets/animation/loader-blue.json';

interface ILoadingProps {
  animation?: string;
  animationStyle?: string;
}

export const Loading: React.FC<ILoadingProps> = ({
  animation,
  animationStyle = 'w-44',
}) => {
  return (
    <div className={`flex justify-center h-full w-full items-center`}>
      <div className={animationStyle}>
        {/* <Lottie
          options={{
            animationData: animation ?? LoaderAnimation,
          }}
        /> */}

        <Lottie animationData={animation ?? LoaderAnimation} loop autoplay />
      </div>
    </div>
  );
};
